import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin, of } from 'rxjs';

import { VacancyCandidatesService } from '../../vacancy-candidates.service';
import { VacancyCandidate, Process, Step, Vacancy, Company  } from '../../../core/models';
import { FilterByParamsPipe } from '../../../core/pipes/filter-by-params.pipe';
import { NotificationsService } from '../../../core/services/notifications.service';
import { NgxHotjarService } from 'ngx-hotjar';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { CompaniesService, StorageService, UserService } from '../../../core/services';
import { BulkActionsLoadingModalComponent } from '../bulk-actions-loading-modal/bulk-actions-loading-modal.component';
import { CandidateListService } from '../../candidates-list/candidates-list.service';
import { mergeMap, take } from 'rxjs/operators';
import { ScheduleService } from '../../scheduling/scheduling.service';
import { VacanciesService } from '../../vacancies.service';
import { CreateShortlistEventComponent } from '../create-shortlist-event/create-shortlist-event.component';
@Component({
  selector: 'app-come-back-candidate-to-previous-step-modal',
  templateUrl: './come-back-candidate-to-previous-step-modal.component.html',
  styleUrls: ['./come-back-candidate-to-previous-step-modal.component.scss']
})

export class ComeBackCandidateToPreviousStepComponent implements OnInit {
  @Input() candidates: VacancyCandidate[];
  @Input() process: Process;
  @Input() filters: Object;
  @Input() vacancy: Vacancy;
  @Input() vacancyId: Number;
  @Input() selectedCandidatesCount: Number;
  @Input() blockSteps: boolean;
  @Input() bulkCandidatesSelected: Boolean;
  @Input() bulkCandidatesIds: string[];
  @Input() limitCandidatesPerRequest: number = 1;
  @ViewChild('select') selectElement: ElementRef;
  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;

  public currentProcessStepIndex: number = 0;

  notificationTaqe;

  finalizedCandidatesCount: number;
  hasCandidatePreApprovedHere: Boolean;
  vacancyCandidateIds: string[];
  loading: string;
  LENGTH: number;
  params: any;

  previousStep: Step;
  previousStepId: string;

  message: string;
  scheduleId: string;
  notificate = true;
  errataNotification = false;
  observations: string;

  public company: Company;
  private allOptions: any[];
	public filteredOptions: any[] = [];
	public selectedOptions: any[] = [];
	public externalJob: any;
	public externalOpportunityMinDate = new Date(0);

  public shortlistByStep: any = {};
  public shortlistId!: string;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private vacancyCandidatesService: VacancyCandidatesService,
    private filterByParamsPipe: FilterByParamsPipe,
    private candidateListService: CandidateListService,
    private toastrService: ToastrService,
    private notificationsService: NotificationsService,
    protected $hotjar: NgxHotjarService,
    private router: Router,
    public userService: UserService,
    private scheduleService: ScheduleService,
    private ref: ChangeDetectorRef,
    private vacanciesService: VacanciesService,
    private storageService: StorageService,
    private companiesService: CompaniesService,
  ) { }

  ngOnInit() {
    this.company = this.storageService.getCompany();
    this.company = this.storageService.getCompany();
    this.$hotjar.virtualPageView(`${environment.web_link}${this.router.url}`);
    this.LENGTH = this.limitCandidatesPerRequest ? this.limitCandidatesPerRequest : 50;
    this.loading = 'stopped';
    this.finalizedCandidatesCount = 0;

    this.vacancy = JSON.parse(JSON.stringify(this.vacancy));
    this.process = JSON.parse(JSON.stringify(this.process));

    this.vacancy.process.steps = this.vacancy.process.steps.filter((step: any) => String(step.key) !== 'general' && String(step.key) !== 'matches');
    this.process = this.vacancy.process;

    this.updatePreviousStepData();

    this.vacanciesService.getVacancyShortlistBySteps(this.vacancy._id)
      .subscribe((shortlists: any) => {
        this.shortlistByStep = shortlists;
        this.filterGroupedShortlists();
      });

    this.notificationsService.getVacancyNewAllNotificatons(this.vacancy._id)
      .subscribe((notifications: any) => {
        this.notificationTaqe = notifications.general.find(element => String(element.key) === 'come_back_to_previous_step');
      });

    this.vacanciesService.getVacancyShortlistBySteps(this.vacancy._id)
      .subscribe((shortlists: any) => {
        this.shortlistByStep = shortlists;
        this.filterGroupedShortlists();
      });
    
    if (this.company.canUseExternalJobList) {
			this.companiesService.getExternalJobs(this.company._id, {
				filters: {
					vacancyId: this.vacancyId
				}
			})
				.subscribe((response: any[]) => {
					this.allOptions = response;
					this.filteredOptions = this.filterOptions(null);
				})
		}
  }

  updatePreviousStepData(freezeStep = false) {
    if (this.candidates) {
      this.currentProcessStepIndex = this.process.steps.findIndex(step => String(step._id) === String(this.candidates[0].currentProcessStepId));

      if (this.currentProcessStepIndex === -1 || this.currentProcessStepIndex === 0 || (this.currentProcessStepIndex - 1) === 0) {
        this.previousStepId = this.process.steps[0]._id;
      } else if (!freezeStep) {
        this.previousStepId = this.process.steps[this.currentProcessStepIndex - 1]._id;
      }

      this.vacancyCandidateIds = this.vacancyCandidateIds = this.generateCandidateIdsInBulk(this.candidates.map(candidate => String(candidate._id)));
    }

    this.previousStep = Object.assign({}, this.process.steps.find(step => String(step._id) === String(this.previousStepId)));
    this.filterGroupedSchedules();
  }

  reloadVacancyAllData() {
    this.vacanciesService.getVacancyById(this.vacancyId)
      .pipe(take(1))
      .subscribe((res: Vacancy) => {
        this.vacancy = res;

        this.candidateListService.setVacancyProcessSteps(this.vacancy);

        this.vacancy.process.steps = this.vacancy.process.steps.filter((step: any) => String(step.key) !== 'general' && String(step.key) !== 'matches');
        this.process = this.vacancy.process;

        this.updatePreviousStepData(true);
        this.candidateListService.updateVacancy(this.vacancy);
      });
  }

  getUserFullName(user: any) {
    return this.userService.getUserFullName(user);
  }

  getVacancyCandidateStepIndex(previousStepId: string): number {
    // tslint:disable-next-line:max-line-length
    return this.process.steps.findIndex(step => String(step._id) === String(previousStepId ? previousStepId : this.candidates[0].currentProcessStepId));
  }

  onPreviousStepChange() {
    this.scheduleId = '';
    this.shortlistId = ''
    this.previousStep = Object.assign({}, this.process.steps.find(step => String(step._id) === String(this.previousStepId)));
    this.filterGroupedSchedules();
    this.filterGroupedShortlists();

    if (this.showExternalOpportunitiesList()) {
			let interval = setInterval(() => {
				this.inputElement.nativeElement.focus();
				clearInterval(interval);
			}, 10)
		}
  }

  filterGroupedSchedules() {
    if (!this.previousStep.schedules || !this.previousStep.schedules.length) {
      return;
    }

    this.previousStep.groupedSchedules = this.filterByParamsPipe.transform((this.previousStep.groupedSchedules || []), {
      pastDates: false
    });

    this.previousStep.groupedSchedules.forEach(group => {
      group.schedules = this.filterByParamsPipe.transform(group.schedules, {
        isPastDate: false
      });

      if (!group.schedules || group.schedules.length === 0) {
        const groupIndex = this.previousStep.groupedSchedules.findIndex(_group => _group === group);
        this.previousStep.groupedSchedules.splice(groupIndex, 1);
      }
    });
  }

  async comeBackCandidates() {
    const hasCandidateWithoutCpf = this.candidates.some(function(candidate) {
			const cpf =
				candidate.user &&
				candidate.user.identificationDocuments &&
				candidate.user.identificationDocuments.cpf;

			return !cpf || cpf.trim() === '';
		});

		if (hasCandidateWithoutCpf && this.previousStep.integrationEnabled) {
			this.toastrService.clear();
			this.toastrService.error(
				'Preencha o CPF do candidato antes de movê-lo para a etapa de integração.',
				'CPF obrigatório!'
			);
			return;
		}

		if (this.showExternalOpportunitiesList() && !this.externalJob) {
			this.inputElement.nativeElement.blur();
			this.toastrService.clear();
			this.toastrService.error('Selecione uma vaga externa para prosseguir.', 'Ação necessária!');
			return;
		}



    if (this.loading === 'running') {
      return;
    }

    if (this.currentProcessStepIndex <= 0) {
      this.toastrService.clear();
      this.toastrService.info('Impossível movimentar candidatos para uma etapa anterior a atual.', 'Ação bloqueada!');
      return;
    }

    if (this.previousStep.key === 'scheduling' && !this.scheduleId) {
      this.toastrService.clear();
      this.toastrService.info('Selecione uma data do agendamento para prosseguir.', 'Agendamento não declarado!');
      return;
    }

    if (this.previousStep.key === 'scheduling' && this.scheduleId) {
      const result = await this.scheduleService.validateSchedule(this.previousStep.schedules, this.scheduleId);
      if (!result) return;
    }

    if (this.previousStep.key === 'shortlist' && !this.shortlistId) {
			this.toastrService.clear();
			this.toastrService.info('Selecione uma shortlist para prosseguir.', 'Shortlist não declarada!');
			return;
		}

    if (this.filters) {
      const params = {
        vacancyId: this.vacancyId,
        filters: this.filters
      };

      this.vacancyCandidatesService.getVacancyCandidatesIds(params)
        .subscribe(results => {
          this.vacancyCandidateIds = results;
          this.repeatComeBack();
        });
    } else {
      this.repeatComeBack();
    }
  }

  repeatComeBack() {
    const requests: Observable<any>[] = [];
    this.loading = 'running';
    let index = 0, modal, interval;
    const numberOfSimultaneousRequests: number = 10;

    do {
      const vacancyCandidateIds = Object.assign([], this.vacancyCandidateIds.splice(0, this.vacancyCandidateIds.length <
        this.LENGTH ?
        this.vacancyCandidateIds.length :
        this.LENGTH)
      );

      let candidatesCount, maxCandidatesCount;
      if (this.previousStep.key === 'scheduling') {
        this.previousStep.groupedSchedules.map(group => group.schedules.map(schedule => {
          if (schedule._id === this.scheduleId) {
            candidatesCount = schedule.candidatesCount;
            maxCandidatesCount = schedule.maxCandidatesCount;
          }
        }));
      }

      this.params = {
        previousStepId: this.previousStepId,
        observations: this.observations,
        notificate: this.notificate,
        errataNotification: this.errataNotification,
        vacancyCandidateIds: vacancyCandidateIds,
        filters: this.filters,
        vacancyId: this.vacancyId,
        scheduleId: this.previousStep.key === 'scheduling' ? this.scheduleId : undefined,
        shortlistId: this.previousStep.key === 'shortlist' ? this.shortlistId : undefined,
        candidatesCount: candidatesCount,
        maxCandidatesCount: maxCandidatesCount,
        externalOpportunities: this.selectedOptions || []
      };

      requests.push(
        this.comeBack(this.params)
      );
      index++;
    } while (this.vacancyCandidateIds.length > 0);

    if (this.bulkCandidatesSelected) {
      modal = this.modalService.open(BulkActionsLoadingModalComponent, {
        backdrop: 'static',
        keyboard: false,
        size: 'lg'
      })

      this.closeModal(); // Deve fechar o modal se a ação for em massa.

      interval = setInterval(() => {
        this.candidateListService.updateCandidatesList(true);
      }, 10000)
    }

    of(...requests).pipe(
      mergeMap(request => request, numberOfSimultaneousRequests),
      forkJoin
    )
      .subscribe((response: any) => {
        this.loading = 'finalized';
        if (this.candidates.length === 1) {
          this.toastrService.clear();
          this.toastrService.success('O candidato <b>' + this.userService.getUserFullName(this.candidates[0].user) + '</b> voltou para a etapa anterior.', 'Candidato movido!', {
            enableHtml: true
          });
        } else {
          this.toastrService.clear();
          this.toastrService.success('Os candidatos voltaram para a etapa anterior.', 'Candidatos movido!');
        }

        if (this.bulkCandidatesSelected) {
          clearInterval(interval);
          this.candidateListService.updateCandidatesList(true);
          modal.close();
          return;
        }

        this.closeModal();
      }, (err) => {
        if (this.bulkCandidatesSelected) {
          clearInterval(interval);
          this.candidateListService.updateCandidatesList(true);
          modal.close();
        }
      });
  }

  comeBack(params) {
    return Observable.create(observer => {
      this.vacancyCandidatesService.bulkComeBackVacancyCandidatepreviousStep(params)
        .subscribe(response => {
          if (!this.filters && !this.bulkCandidatesSelected) {
            for (const data of response) {
              if (data.response) {
                this.candidates.find(candidate => candidate._id === data._id).currentProcessStepId = this.previousStepId;
              }
            }
          } else {
            this.finalizedCandidatesCount += response && response.length ? response.length : 0;
          }

          observer.next();
          observer.complete();
        }, error => observer.error(error));
    });
  }

  closeModal() {
    if (this.loading === 'finalized' || this.loading === 'running') {
      this.activeModal.close(this.params);
    } else {
      this.activeModal.close(false);
    }
  }

  async clickModalScheduling() {
    const id = await this.scheduleService.openModalScheduling(
      this.vacancy,
      String(this.vacancyId),
      this.ref,
      this.reloadVacancyAllData.bind(this)
    );

    if (id) {
      this.scheduleId = id; // atualiza a agendamento selecionado
    }
  }

  public toggleCheckbox(checkbox: string): void {
    if (checkbox === 'notificate') {
      this.errataNotification = false;
    } else if (checkbox === 'errataNotification') {
      this.notificate = false;
    }
  }

  private generateCandidateIdsInBulk(candidateIdOnScreen: string[]): string[] {
    if (!this.bulkCandidatesIds || !this.bulkCandidatesIds.length) {
      return candidateIdOnScreen;
    }

    return Array.from(new Set(candidateIdOnScreen.concat(this.bulkCandidatesIds)));
  }

	private filterGroupedShortlists(): void {
		this.previousStep.groupedShortlists = this.shortlistByStep[this.previousStep._id] || [];
	}

  public createShortlist(): void {
    const modal = this.modalService.open(CreateShortlistEventComponent, { backdrop: 'static', keyboard: false, size: 'lg' });
    modal.componentInstance.steps = [this.previousStep];
    modal.componentInstance.vacancyId = this.vacancy._id;

    modal.result.then(response => {
      if (response) {
        this.shortlistByStep[this.previousStep._id] = this.shortlistByStep[this.previousStep._id] || [];
        this.shortlistByStep[this.previousStep._id].unshift(response);
        this.filterGroupedShortlists();
        this.shortlistId = response._id;
      }
    }).catch(err => { });
  }

  public showExternalOpportunitiesList(): boolean {
		return this.previousStep && this.previousStep.key === 'approved' && this.company.canUseExternalJobList;
  }

  public isApprovedStep(): boolean {
    if (!this.process || !this.process.steps) {
      return false;
    }

    if (!environment.redeCidada_ids.includes(String(this.company._id))) {
			return false;
		}

    const step = this.process.steps.find(item =>
      String(item._id) === String(this.previousStepId)
    );

    return !!step &&
        step.key === 'approved' &&
        this.candidates.length > 1;
	}

	private showApprovedToastIfNeeded(): void {
		if (this.isApprovedStep()) {
			this.toastrService.clear();
			this.toastrService.error(
				'Não é possível aprovar vários candidatos simultaneamente para esta etapa.',
				'Atenção!'
			);
		}
  }

  public filterOptions(value: string): any[] {
		let filterValue: string = "";

		if (typeof value === "string") {
			filterValue = value.toLowerCase();
		}

		const selectedItens: string[] = this.selectedOptions.map(element => String(element._id));

		return this.allOptions.filter((option: any) =>
			!selectedItens.includes(String(option._id)) &&
			(
				String(option.externalJobName || '').toLowerCase().includes(filterValue) ||
				String(option.externalJobId || '').toLowerCase().includes(filterValue) ||
				String(option.externalCompanyId || '').toLowerCase().includes(filterValue)
			)
		);
	}
  
  public optionSelected(option: any): void {
		this.selectedOptions.push(option);
		this.inputElement.nativeElement.blur();
	}

  public removeExternalJob(): void {
		delete this.externalJob;
		this.selectedOptions = [];
	}

	public displayWith(option: any): string {
		return option ? `${option.externalJobName}` : '';
	}

  public searchExternalJob(value: string): void {
		this.filteredOptions = this.filterOptions(value);
	}
}
